import React, { useState, FC } from "react";
import { Typography, Button, Modal, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import getModalStyle from "../../../util/getModalStyle";
import {
  StyledModalDiv,
  RowLayout,
  ColLayout,
} from "../../../util/accordianStyles";
import useCustomSalesTaxSelector from "./useCustomSalesTaxSelector";

interface CustomSalesTaxProps {
  quoteId: string;
  isFetching: boolean;
}

const CustomSalesTax: FC<CustomSalesTaxProps> = ({ quoteId, isFetching }) => {
  const {
    changeSalesTax,
    handleCustomTax,
    handleOpen,
    open,
    customTax,
    handleClose,
  } = useCustomSalesTaxSelector(quoteId, isFetching);

  return (
    <>
      <TaxModal
        open={open}
        handleClose={handleClose}
        customTax={customTax}
        handleCustomTax={handleCustomTax}
        changeSalesTax={changeSalesTax}
      />

      <Tooltip title="Edit Sales Tax" enterDelay={500} placement="top">
        <IconButton onClick={handleOpen} style={{padding:0}}>
          <EditIcon
            style={{ fontSize: 20 }}
            color="primary"
          />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default CustomSalesTax;

interface TaxModalProps {
  open: boolean;
  handleClose: () => void;
  customTax: string | null;
  handleCustomTax: (event: React.ChangeEvent<HTMLInputElement>) => void;
  changeSalesTax: () => void;
}

const TaxModal: FC<TaxModalProps> = ({
  open,
  handleClose,
  customTax,
  handleCustomTax,
  changeSalesTax,
}) => {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const body = (
    <StyledModalDiv style={modalStyle}>
      <ColLayout>
        <h2 id="simple-modal-description">Sales Tax</h2>

        <RowLayout style={{ paddingBottom: 20 }}>
          <Typography variant="subtitle2" style={{ paddingRight: 10 }}>
            Enter Sales Tax:
          </Typography>
          <input
            placeholder="e.g. 9.775"
            step="any"
            type="number"
            value={customTax || ""}
            onChange={handleCustomTax}
            style={{ padding: 5, width: 100 }}
          />
        </RowLayout>

        <RowLayout>
          <Button
            onClick={handleClose}
            variant="contained"
            style={{ marginRight: 10 }}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            onClick={changeSalesTax}
            color="primary"
            variant="contained"
            style={{ marginLeft: 10 }}
          >
            Confirm
          </Button>
        </RowLayout>
      </ColLayout>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};
